// @ts-nocheck
// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  left_brace = 1,
  right_brace = 2,
  math_shift = 3,
  tab_mark = 4,
  car_ret = 5,
  mac_param = 6,
  sup_mark = 7,
  sub_mark = 8,
  ignore = 9,
  spacer = 35,
  letter = 36,
  other_char = 37,
  active_char = 10,
  invalid_char = 11,
  control_sequence_token = 38,
  begingroup_cs_token = 39,
  endgroup_cs_token = 40,
  defcode_cs_token = 41,
  def_cs_token = 42,
  let_cs_token = 43,
  futurelet_cs_token = 44,
  prefix_cs_token = 45,
  directive_comment = 46,
  line_comment = 47,
  Document = 12,
  begingroup_cs = 13,
  endgroup_cs = 14,
  math_shift_group = 15,
  single_math_shift = 16,
  double_math_shift = 17,
  prefix_cs = 18,
  let_cs = 19,
  control_sequence = 20,
  optional_equal = 21,
  futurelet_cs = 22,
  def_cs = 23,
  defcode_cs = 24,
  integer = 25,
  directive = 26,
  Dialect_directives = 0
